<form
  [formGroup]="formGroup"
  [bitSubmit]="submit"
  bit-dialog
  [loading]="loading()"
  [title]="titleKeys[0] | vfo1I18n: titleKeys[1]"
  subtitle=""
>
  <span bitBadge [variant]="policyEnabled() ? 'success' : 'secondary'" bitDialogHeaderEnd>{{
    (policyEnabled() ? "on" : "off") | i18n
  }}</span>
  <ng-container bitDialogContent>
    @if (loading()) {
      <bit-spinner></bit-spinner>
    } @else {
      @let prereqKeys = prerequisiteKeys;
      @let warnKeys = warningKeys;
      @if (prereqKeys) {
        <bit-callout type="info" [title]="'prerequisite' | i18n">
          {{ prereqKeys[0] | vfo1I18n: prereqKeys[1] }}
          @if (policy.prerequisiteLinkHref && policy.prerequisiteLinkTextKey) {
            <a bitLink [href]="policy.prerequisiteLinkHref" target="_blank" rel="noreferrer">
              {{ policy.prerequisiteLinkTextKey | i18n }}
            </a>
          }
        </bit-callout>
      }
      @if (warnKeys) {
        <bit-callout type="warning">{{ warnKeys[0] | vfo1I18n: warnKeys[1] }}</bit-callout>
      }
      @if (policy.showDescription) {
        <p bitTypography="body1">{{ descriptionKeys[0] | vfo1I18n: descriptionKeys[1] }}</p>
      }
      <ng-template #policyForm></ng-template>
    }
  </ng-container>
  <ng-container bitDialogFooter>
    <button bitButton buttonType="primary" [disabled]="saveDisabled()" bitFormButton type="submit">
      {{ "save" | i18n }}
    </button>
  </ng-container>
</form>
